module.exports = __webpack_public_path__ + "static/media/mode-33.4318153a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-33.svg
// module id = 988
// module chunks = 2